exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.base-card-tabbed .sb_component_card_body .v-card__text {\r\n  padding: 0 0 16px 0;\n}\r\n", ""]);

// exports
